import React, { useState, useEffect } from 'react';
import { Modal } from 'react-responsive-modal';
import DesignAuthorCard from '../../Common/DesignCard/DesignAuthorCard/DesignAuthorCard';
import Carousal from '../../Common/Carousal/Carousal';
import 'react-responsive-modal/styles.css';
import './CreativeDesignModal.scss';

const CreativeDesignModal = ({
	isOpen,
	onClose,
  selectedDesign
}) => {

	const [open, setOpen] = useState(isOpen);
	const {
    designTitle,
    designsFiles,
    designerProfile,
    productType
  } = selectedDesign;

  useEffect(() => {
    document.body.parentElement.style.overflow = 'hidden';
    return () => {
      document.body.parentElement.style.overflow = 'auto';
    }
  }, []);

	const designCardImgArr =  [];
  designsFiles.forEach(item => {
    designCardImgArr.push(item.file.url);
  });  

  const onCloseModal = () => {
		onClose();
		setOpen(false); 
	}

  const openCustomiseMe = () => {
    let url = '';
    const [tempProductType] = productType;
    switch (tempProductType) {
      case "Card":
        url = 'https://noissue.co/custom-packaging/custom-cards/design-online/';
        break;
      case "Kraft Mailer":
        url = 'https://noissue.co/custom-packaging/custom-kraft-mailers/design-online/';
        break;
      case 'Stamp':
        url = 'https://noissue.co/custom-packaging/custom-stamps/design-online/';
        break;
      default:
        break;
    }
    window.open(url, '_blank', 'noopener');
  }

	return (
		<Modal open={open} onClose={onCloseModal} classNames={{root : `creative-design-modal`}} center>
			<div className="creative-design-modal-breadcrumb" tabIndex="0">
				<span className="creative-design-modal-breadcrumb-title">Creative Templates {'>'}</span>
				<span className="creative-design-modal-breadcrumb-subtitle">{designTitle}</span>
			</div>
			<div className="creative-design-modal-container">
				<div className="creative-design-modal-left">
					<div className="creative-design-modal-image">
						{/* <CommunityImg src={designCardImg} alt="design" /> */}
            <Carousal imgArr={designCardImgArr} />
					</div>
				</div>
				<div className="creative-design-modal-right">
          <div className="creative-design-details">
            <div className="creative-author-info">
              {/* <div className="creative-author-info-logo creative-design-logo" style={{ backgroundImage: `url(${eventPartnerLogoImg})` }} /> */}
              <div className="creative-author-info-detail">
                <div className="creative-author-info-title">{designTitle}</div>
                <div className="creative-author-info-location"> from $75NZ (+ GST)  </div>
              </div>
            </div>
            <div className="creative-design-modal-btn">
              <button onClick={openCustomiseMe}> Customize Design </button>
            </div>
          </div>
          <DesignAuthorCard designerProfile={designerProfile} />
				</div>
			</div>
		</Modal>
	);
};

export default CreativeDesignModal;